document.addEventListener("DOMContentLoaded", () => {

  const header = document.querySelector(".custom-header");
  const drawer = document.getElementById("CustomDrawer");
  const menuToggle = document.querySelector(".menu-toggle");
  const drawerClose = document.querySelector(".drawer-close");
  const overlay = document.querySelector(".custom-drawer__overlay");

  /* -------------------------
     Sticky Header
  -------------------------- */

  let lastScroll = 0;

  window.addEventListener("scroll", () => {

    if (!header) return;

    if (window.scrollY > 80) {
      header.classList.add("sticky");
    } else {
      header.classList.remove("sticky");
    }

    lastScroll = window.scrollY;

  });

  /* -------------------------
     Open Drawer
  -------------------------- */

  function openDrawer() {

    if (!drawer) return;

    drawer.classList.add("active");

    document.body.style.overflow = "hidden";

  }

  /* -------------------------
     Close Drawer
  -------------------------- */

  function closeDrawer() {

    if (!drawer) return;

    drawer.classList.remove("active");

    document.body.style.overflow = "";

  }

  if (menuToggle) {
    menuToggle.addEventListener("click", openDrawer);
  }

  if (drawerClose) {
    drawerClose.addEventListener("click", closeDrawer);
  }

  if (overlay) {
    overlay.addEventListener("click", closeDrawer);
  }

  /* -------------------------
     ESC Key
  -------------------------- */

  document.addEventListener("keydown", (event) => {

    if (event.key === "Escape") {
      closeDrawer();
    }

  });

  /* -------------------------
     Close Drawer After Click
  -------------------------- */

  const drawerLinks = document.querySelectorAll(".drawer-menu a");

  drawerLinks.forEach((link) => {

    link.addEventListener("click", () => {

      closeDrawer();

    });

  });

  /* -------------------------
     Dropdown Animation
  -------------------------- */

  const details = document.querySelectorAll(".drawer-menu details");

  details.forEach((detail) => {

    detail.addEventListener("toggle", () => {

      if (detail.open) {

        detail.classList.add("opened");

      } else {

        detail.classList.remove("opened");

      }

    });

  });

});